import React from 'react';
import SearchContainer from '../../Appointments/SearchContainer';
import IconButton from '@/ctComponents/IconButton';

const SearchAndFilterBar = ({ filter, setFilter, setOptions }) => {
  const hasAppliedFilters = () => {
    return (
      filter.appliedFilters &&
      Object.entries(filter.appliedFilters).filter(
        ([key, value]) => value && key !== 'search'
      ).length > 0
    );
  };

  return (
    <div className="flex flex-col lg:flex-row gap-3 justify-between lg:items-center my-5">
      <div className="flex flex-wrap flex-col sm:flex-row gap-1 lg:gap-3 py-2 w-full lg:w-auto justify-start">
        <div className="w-full sm:w-268">
          <SearchContainer
            key={filter.search}
            value={filter.search}
            className="box-border"
            width={'100%'}
            placeholder="Search..."
            setContainerName={(value) => {
              setFilter({
                ...filter,
                appliedFilters: { ...filter.appliedFilters, search: value },
              });
            }}
            setPage={() => {}}
          />
        </div>

        <IconButton
          active={filter.open || hasAppliedFilters()}
          text="Filter"
          icon="filter"
          onClick={() => {
            setFilter({ ...filter, open: filter.open ? false : true });
            setOptions({ open: false, DATA: [] });
          }}
        />
      </div>
    </div>
  );
};

export default SearchAndFilterBar;
